import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon } from '../../../config/variables';
import { navigateRoute } from '../../../utils/HelperFunctions';
import { ITermsAndConditions } from '../types/interfaces';
import { ITableContainerProps } from '../../../types/Interfaces';
import DeleteButton from '../../../components/buttons/DeleteButton';

const TermsAndConditionsTable = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<ITermsAndConditions[]>) => {
    const navigate = useNavigate();
    const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

    return (
        <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
            <div className="table_header">
                {tableHeaders?.map((header, index) =>
                    !header ? null : (
                        <span className={`head ${header.customClass}`} key={index}>
                            {header.label}
                        </span>
                    )
                )}
            </div>
            <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
                {data?.length > 0 ? (
                    <>
                        {data?.map((item, index) => (
                            <div
                                className="item clickable"
                                key={index}
                                onClick={(e) => {
                                    navigateRoute(e, `/terms-and-conditions/create-terms-and-conditions/${item.id}`, navigate);
                                }}
                            >
                                <div className="column">{item?.type || '-'}</div>

                                <div className="column actions actions_col">
                                    <div
                                        className="action_btn edit"
                                        onClick={(e) => {
                                            navigateRoute(e, `/terms-and-conditions/create-terms-and-conditions/${item.id}`, navigate);
                                        }}
                                    >
                                        {editIcon}
                                    </div>
                                    <div onClick={(e) => {
                                        e.stopPropagation()
                                    }}>
                                        <DeleteButton deleteRoute={`/admin/cms/terms-and-conditions`} queryKey="terms-and-conditions" id={item.id} />
                                    </div>
                                </div>

                            </div>
                        ))}
                    </>
                ) : (
                    <h6>{noDataMessage}</h6>
                )}
            </div>
        </div>
    );
};

export default TermsAndConditionsTable;
